import { render, staticRenderFns } from "./ReturnSolicitation.vue?vue&type=template&id=0087efeb&scoped=true&"
import script from "./ReturnSolicitation.vue?vue&type=script&lang=js&"
export * from "./ReturnSolicitation.vue?vue&type=script&lang=js&"
import style0 from "./ReturnSolicitation.vue?vue&type=style&index=0&id=0087efeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0087efeb",
  null
  
)

export default component.exports